import { useState } from "react";
import LogOutComponent from "../LogOut/LogOut";
import { Logo } from "../UI";
import { sideBarElements } from "./elements";
import SideBarElement from "./SideBarElement";
import { motion } from "framer-motion";
import { ChevronIcon } from "../icon";
import { cn } from "@/common/utils";
import { usePermissions } from "@/common/contexts/Permissions.context";
import { CompanyType } from "@/common/types";
import { useWebSocketContext } from "@/common/contexts/Websocket.context";

export default function SideBar() {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { company, isHavePermission } = usePermissions();
  const { lastMessage } = useWebSocketContext();

  const data = lastMessage?.data;
  let count: number = 0;

  if (typeof data === "string") {
    try {
      const parsedMessage = JSON.parse(data);
      count = parsedMessage.count ?? 0;
    } catch (error) {
      console.error("Error parsing lastMessage.data:", data, error);
    }
  }

  const logoWrapper = isOpen ? "mb-[30px]" : "mb-[15px]";
  const companyType: CompanyType = company?.companyType || "vendor";

  return (
    <motion.div
      initial={{ maxWidth: 263 }}
      animate={{
        maxWidth: isOpen ? 263 : 142,
        transition: {
          duration: 0.5,
        },
      }}
      className="sticky top-0 left-0 py-6 flex flex-col w-full px-2.5 pr-0 bg-black rounded-r-2xl pb-10 h-screen"
    >
      <div className="flex h-full ">
        <div className="flex justify-between flex-col ">
          <div>
            <div className={logoWrapper}>
              <Logo />
            </div>
            {!!company &&
              sideBarElements[
                companyType as "airx" | "vendor" | "customer"
              ].map((el: any) => {
                if (el.label === "Quotes") {
                  if (companyType === "customer") {
                    return isHavePermission("quotes_customer_view") ? (
                      <SideBarElement
                        key={el.to}
                        element={el}
                        isOpen={isOpen}
                        count={count}
                      />
                    ) : null;
                  }
                  if (isHavePermission("quotes_vendor_view")) {
                    return (
                      <SideBarElement
                        key={el.to}
                        element={el}
                        isOpen={isOpen}
                        count={count}
                      />
                    );
                  }
                  return null;
                }
                return (
                  <SideBarElement
                    key={el.to}
                    element={el}
                    isOpen={isOpen}
                    count={count}
                  />
                );
              })}
          </div>
          <LogOutComponent />
        </div>

        <button
          className="text-white w-6 flex justify-center items-center pr-2"
          onClick={() => setIsOpen((state) => !state)}
        >
          <span
            className={cn(
              !isOpen ? "rotate-180 " : "rotate-0 ",
              " transition-all duration-500"
            )}
          >
            <ChevronIcon />
          </span>
        </button>
      </div>
    </motion.div>
  );
}
